import type { Service } from "@/types/Service";
import formConfigFixture from "@/fixtures/formConfig.json";
import type { FormConfig } from "@/types/FormConfig";
import { BRAINTREE_AUTHORIZATION } from "@/config";

export const previewService: Service = {
  name: "preview",
  getFormConfig: async () => {
    if (window.__FORM_CONFIG__) {
      return {
        ...window.__FORM_CONFIG__,
        active: true,
      } as FormConfig;
    }

    return formConfigFixture as unknown as FormConfig;
  },
  getPaymentToken: async () => {
    return {
      token: BRAINTREE_AUTHORIZATION,
    };
  },
  sendSubmission: async (params) => {
    return {
      success: true,
      submission: {
        form_id: params.form_id,
        ip: "127.0.0.1",
        updated_at: "2025-03-22T16:22:41.000000Z",
        created_at: "2025-03-22T16:22:41.000000Z",
        id: 13,
      },
      donation_reference: "V00000001",
      amount: 100,
      amount_gift: 25,
      missing_components: {
        gift_aid: !(params.fields.gift_aid?.gift_aid ?? false),
        signup_frontline: !(
          params.fields.sign_up_to_frontline?.sign_up_frontline ?? false
        ),
      },
    };
  },
  validateBankDetails: async () => {
    return true;
  },
  getRetrieveAvailableDates: async () => {
    return {
      "available-dates": ["2025-05-15", "2025-05-28", "2025-06-01"],
    };
  },
  sendGiftAid: async () => {},
  sendSignUpFrontline: async () => {},
};
